module.exports = __webpack_public_path__ + "media/images/suppliers/newmarketscientific-64199388edf9cbc11e719335a73ec39f.png";